import React from 'react'
import PropTypes from 'prop-types'
import './styles.scss'

const Program = ({ post, link }) => (
  <div className={'program-one'} key={post.id}>
    <div className={'program-one__image'}>
      {post.image && <img src={post.image} />}
      {post.kategorien.length && (
        <div className={'program-one__cats'}>
          {post.kategorien.map(category => (
            <span key={category.term_id} className={post.colorClass}>
              {category.name}
            </span>
          ))}
        </div>
      )}
    </div>
    <div className={'program-one__text'}>
      <h3
        className={'program-one__title'}
        dangerouslySetInnerHTML={{
          __html: post.title,
        }}
      />
      <a className={'vc-button button whisper icon'} href={post.link}>
        {link}
        <i className="btb bt-arrow-right"></i>
      </a>
    </div>
  </div>
)

Program.propTypes = {
  post: PropTypes.object.isRequired,
  link: PropTypes.string.isRequired,
}

export default Program
